import { useState, ComponentType } from "react";
import { FeedbackEntry } from "./index";

export interface FeedbackContainerProps {
  feedback?: FeedbackEntry[];
  onShowFeedback: (feedback: FeedbackEntry | FeedbackEntry[]) => void;
  onHideFeedback: (id: string) => void;
}

function withFeedback<T extends FeedbackContainerProps>(
  Component: ComponentType<T>
) {
  // Try to create a nice displayName for React Dev Tools.
  const displayName = Component.displayName || Component.name || "Component";
  const ComponentWithFeedback = (
    props: Omit<T, keyof FeedbackContainerProps>
  ) => {
    const [feedback, setFeedback] = useState<FeedbackEntry[]>([]);
    const removeFeedback = (id: string) => {
      setFeedback(feedback.filter((val) => val.id !== id));
    };
    const addFeedback = (f: FeedbackEntry | FeedbackEntry[]) => {
      // filter out feedback with same id
      if (Array.isArray(f)) {
        setFeedback((cur) =>
          cur.filter((val) => !f.find((v) => v.id === val.id)).concat(f)
        );
      } else {
        setFeedback((cur) => cur.filter((val) => val.id !== f.id).concat(f));
      }
    };
    return (
      <Component
        {...(props as T)}
        feedback={feedback}
        onShowFeedback={addFeedback}
        onHideFeedback={removeFeedback}
      />
    );
  };
  ComponentWithFeedback.displayName = `withFeedback(${displayName})`;

  return ComponentWithFeedback;
}

export default withFeedback;
